/*
 * Copyright (c) Vaisala Oyj. All rights reserved.
 */

import { RadioButton, RadioGroup } from '@vaisala-rockhopper/components';
import React from 'react';
import { ModalInstance, ModalProps } from './Modals';
import { SuperscriptBlock } from '../utils/SuperscriptBlock';
import './Modals.scss';

export interface OptionsModalProps extends ModalProps {
  optionsConfig: OptionsConfig;
}

export interface OptionsConfig {
  options: string[];
  selectedIndex: number;
  onSelect: (i: number) => void;
}

export const OptionsModal = (props: OptionsModalProps) => {
  const { options, onSelect, selectedIndex } = props.optionsConfig;
  const [value, setValue] = React.useState(`${selectedIndex}`);
  const onChange = (val: string) => {
    setValue(val);
    onSelect(parseInt(val));
  };
  return (
    <ModalInstance modalId="modal.options" {...props}>
      {options && (
        <RadioGroup className="options-radio-group" onChange={(evt) => onChange(evt.target.value)} value={value}>
          {options.map((option, i) => (
            <RadioButton key={i} value={`${i}`}>
              <SuperscriptBlock text={option} />
            </RadioButton>
          ))}
        </RadioGroup>
      )}
    </ModalInstance>
  );
};
